import { ArrowDown, ArrowUp, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ReorderButtonsProps {
  index: number;
  total: number;
  itemLabel: string;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onRemove: () => void;
  disabled?: boolean;
}

export function ReorderButtons({
  index,
  total,
  itemLabel,
  onMoveUp,
  onMoveDown,
  onRemove,
  disabled = false,
}: ReorderButtonsProps) {
  return (
    <div className="flex shrink-0 items-center gap-1">
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        disabled={disabled || index === 0}
        onClick={onMoveUp}
        aria-label={`Move ${itemLabel} up`}
      >
        <ArrowUp className="size-3.5" />
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        disabled={disabled || index === total - 1}
        onClick={onMoveDown}
        aria-label={`Move ${itemLabel} down`}
      >
        <ArrowDown className="size-3.5" />
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        disabled={disabled}
        onClick={onRemove}
        className="text-destructive hover:bg-destructive/10 hover:text-destructive"
        aria-label={`Remove ${itemLabel}`}
      >
        <Trash2 className="size-3.5" />
      </Button>
    </div>
  );
}
